<template>
  <div class="supervision">
    <div class="banner" ref="Banner">
      <div class="action-title">
        <div class="action-lf">
          <span class="all-group" v-if="selectGroupObj.length === 0">全部小组</span>
          <a-button type="primary" @click="showGroupTable" style="margin: 0 4px">
            选择小组和讲次
          </a-button>
          <a-button v-gdd-hide style="margin-left: 14px;margin: 0 4px" type="danger" @click="pause">
            一键暂停
          </a-button>
          <a-button v-gdd-hide style="margin-left: 14px;margin: 0 4px" type="danger" @click="speedStopClick">
            禁用倍速
          </a-button>
          <span class="learning">
            <span style="color: #c1c6d0">正在学习：</span>{{ studyingStudentNumber || 0 }}人
          </span>
          <span v-gdd-hide class="not-learning" @click="showAbsentees">
            <span>未开始学习</span>
            <span class="right-icon-box">
              <SvgIcon icon="arrowRight" class="right-icon" />
            </span>
          </span>
          <span class="tips">
            <SvgIcon icon="exclamation-mark" class="info-icon" />
            注意：24小时内，若学生中止学习且无任何数据更新，将自动从看板中消失
          </span>
        </div>
        <div class="action-rt">
          <a-button v-show="selectGroupObj.length > 0" @click="clearAll" type="link" class="reset">
            <i class="iconfont icon-clear-copy clear-all-icon" />
            清空筛选
          </a-button>
          <a-button
            :loading="refreshLoading"
            icon="sync"
            @click="refresh"
            style="border: 1px solid #fff;color:#fff;background: transparent"
            class="refresh"
          >
            刷新
          </a-button>
          <a-button v-gdd-hide v-if="hasJzxGroup" @click="handleClassin" class="enter-calss">
            进入授课 <i class="iconfont icon-jinru" @click="delGroup(idx, group.id)" />
          </a-button>
        </div>
      </div>
      <ul class="group-list" v-if="selectGroupObj.length > 0" ref="GroupListRef" :class="[showAll ? 'show-all' : 'show-one']">
        <a-tooltip :title="group.composeName" overlay-class-name="draw_atooltip" v-for="(group, idx) in selectGroupObj" :key="group.id">
          <li>
            <span class="name">{{ group.composeName }}</span>
            <i class="iconfont icon-close close-icon" @click="delGroup(idx, group.id)" />
          </li>
        </a-tooltip>
      </ul>
      <p v-if="showToggleBtn" class="toggle-height">
        <span @click="toggleGroupShow">{{ !showAll ?'点击展开': '点击收起' }}</span>
        <a-icon v-if="showAll" type="up" style="fontSize: 10px" />
        <a-icon v-else type="down" style="fontSize: 10px" />
      </p>
    </div>
    <div class="table-wrap" :class="[lt1280 ? 'add-fix-table-boxshow' : '']">
      <a-table
        class="diy-style-table"
        ref="table"
        :row-key="(record) => {
          return record.userId + '' + record.lessonId
        }"
        :scroll="scroll"
        :columns="columns"
        :data-source="studentList"
        :pagination="false"
        :locale="locale"
        @change="onTableChange"
      >
        <span slot="customTitle">
          语音互动次数
          <a-tooltip placement="left" overlay-class-name="draw_atooltip">
            <template slot="title">
              <p>"语音测评"，"语音红包"，"打飞机背单词"的参与次数</p>
            </template>
            <a-icon class="tip-icon" type="exclamation-circle" style="padding-top: 4px" />
          </a-tooltip>
        </span>
        <template slot="studentName" slot-scope="text, row">
          <div class="student">
            <div class="name">
              <a-tooltip overlay-class-name="draw_atooltip" placement="topLeft">
                <template slot="title">
                  {{ text }}
                </template>
                {{ text }}
              </a-tooltip>
            </div>
            <span class="duration">总用时：{{ row.totalStudyTime ? filters.msToMinAndSeconds(row.totalStudyTime) : '--' }}</span>
          </div>
        </template>
        <div slot="lessonTag" class="lesson" slot-scope="text, row">
          <span v-if="row.experience === 1" class="try-course">体验课</span>
          <span class="tags">
            <span class="subject">{{ row.subjectName }}</span>
            <span class="semester" v-if="row.lessonTag !== 0">{{ row.lessonTag === 1 ? '期中' : '期末' }}</span>
          </span>
          <div class="lesson-name">
            <a-tooltip :title="row.lessonName" overlay-class-name="draw_atooltip">
              {{ row.lessonName }}
            </a-tooltip>
          </div>
          <div class="group-name">
            <a-tooltip :title="row.groupName" overlay-class-name="draw_atooltip">
              {{ row.groupName }}
            </a-tooltip>
          </div>
        </div>
        <div slot="percent" class="td-box percent" slot-scope="text, row">
          <a-progress
            :gap-degree="50"
            gap-position="bottom"
            width="70px"
            stroke-width="8"
            :stroke-color="getStrokeColor(row)"
            :percent="getPercent(row)"
            type="dashboard"
          >
            <template #format="percent">
              <span
                class="percent-num"
                :style="{color: getStrokeColor(row)}"
              >
                <span class="num">{{ percent }}</span><span v-if="percent >= 0">%</span>
              </span>
            </template>
          </a-progress>
        </div>
        <div slot="answerNum" class="answer" slot-scope="text, row">
          <div class="answer">
            <span class="answer-num">{{ text || 0 }}</span><span class="answer-total">/{{ row.answerTotal || 0 }}次</span>
          </div>
        </div>
        <!-- https://yapi.aixuexi.com/project/42/interface/api/193529 行为类型（1:学AI课中...,2:答题中...,3:参与（%s互动）中...,4:已提交%s,5:学员已完成学习,6:学员中途退出,7:学生已学完ai课，8：课前学习中，9：课前学习完，10：课后学习中，11：课后学习完）	-->
        <div slot="currentBehavior" class="behavior" slot-scope="text">
          <span class="behavior-des">{{ text && text.name }}</span>
          <span v-if="text && text.type === 2" class="behavior-time" :style="{'color': text && text.behaviorTime > 5 * 60 * 1000 ? '#FF5C5C' : '#98A2B2'}">答题用时：{{ text && filters.msToMmSs(text.behaviorTime) }}</span>
          <span v-if="text && text.speed && (text.speed * 100) > 100" class="speed">
            {{ text.speed }}倍速
          </span>
        </div>
        <div slot="studyProgress" slot-scope="text, row">
          <TagList :moudle-list="row.moudleInfoList" :is-old-data="Number(row.coursewareVersion) === -1" :study-progress="text" :period="row.lessonTag" />
        </div>
        <div slot="interactedNum" class="interacted" slot-scope="text, row">
          <span class="interacted-num">{{ text || 0 }}</span><span class="interacted-total">/{{ row.interactTotal || 0 }}次</span>
        </div>
        <div slot="voiceInteractedNum" class="interacted" slot-scope="text, row">
          <span class="interacted-num">{{ text || 0 }}</span><span class="interacted-total">/{{ row.voiceInteractTotal || 0 }}次</span>
        </div>
      </a-table>
    </div>

    <!-- 缺勤人员弹窗 -->
    <Absentees :visible.sync="absenteesVisible" :group-ids="absenteesGroupIds" />

    <!-- 小组弹窗 -->
    <div v-if="groupVisible">
      <GroupModal
        :init-group-lesson="selectGroupObj"
        :visible.sync="groupVisible"
        @onOk="groupSubmit"
      />
    </div>

    <!-- 暂停弹窗 -->
    <PauseModal :visible.sync="pauseVisible" :group-arr="selectGroupObj" />
    <SpeedStop :visible.sync="speedStopVisible" :group-arr="studentList" />
  </div>
</template>

<script>
import filters from '@/filters'
import { reactive, toRefs, ref, onMounted, onBeforeUnmount, onUnmounted, watch } from '@vue/composition-api'
import { useGetStudentList } from './hooks'
import Absentees from './coms/absentees.vue'
import GroupModal from './coms/groupModal.vue'
import PauseModal from './coms/pauseModal.vue'
import SpeedStop from './coms/speedStop.vue'
import { getColumns } from './columns'
import TagList from './coms/tagList.vue'
import Empty from './coms/empty.vue'
import supervisionLogger from '@/utils/logger/supervision.js'
import Moment from 'moment'
// import { coinSocket } from '@/utils/websocket/coinSocket'
import { throttle } from 'lodash'
import service from '@/service/supervision'

export default {
  name: 'SupervisionList',

  components: {
    Absentees,
    GroupModal,
    TagList,
    PauseModal,
    SpeedStop
  },

  data() {
    return {
      locale: {
        emptyText: <Empty />
      }
    }
  },

  setup(props, { root, refs }) {
    supervisionLogger.initPageLogger()
    const GroupListRef = ref(null)
    const Banner = ref(null)
    // const scroll = reactive({ x: 1190, y: 0 })
    const scroll = reactive({ x: 1605, y: 0 })
    const state = reactive({
      refreshLoading: false,
      actionTips: false,
      absenteesVisible: false, // 缺勤人员
      absenteesGroupIds: [],
      groupVisible: false,
      pauseVisible: false,
      showAll: true,
      showToggleBtn: false,
      selectGroupObj: [],
      lt1280: false, // 小于1280控制固定列投影
      columns: getColumns(),
      hasJzxGroup: false,
      speedStopVisible: false
    })

    // const { socketRun } = coinSocket()
    // socketRun()

    const methods = {
      handleClassin() {
        const { href } = this.$router.resolve({
          name: 'inJzxCommonPage',
          query: {
            pageType: 3,
            sourceType: 1
          }
        })
        window.open(href, '_blank')
      },
      setTableColumnsWidth() {
        state.columns.forEach(k => {
          if (state.lt1280) {
            if (k.dataIndex === 'studentName') {
              k.width = 116
            }
          } else {
            if (k.dataIndex === 'studentName') {
              k.width = 160
            }
          }
        })
      },
      onTableChange: (pagination, filters, sorter, { currentDataSource }) => {
        sessionStorage.setItem('supervision_sorter', JSON.stringify({ field: sorter.field, order: sorter.order }))
      },
      getStrokeColor: row => {
        const grey = '#505873'
        const red = '#FF5C5C'
        const green = '#06C270'
        const { answerRate } = row
        if (answerRate === -1 || (!answerRate && answerRate !== 0)) return grey
        if (answerRate >= 0 && answerRate < 50) return red
        if (answerRate >= 50) return green
        return grey
      },
      getPercent: row => {
        const { answerRate } = row
        if (answerRate === -1 || (!answerRate && answerRate !== 0)) return '--'
        return answerRate
      },
      showAbsentees: () => {
        supervisionLogger.notStudyLogger()
        state.absenteesGroupIds = [...new Set(state.selectGroupObj.map(k => (String(k.id).includes('_') ? k.id.split('_')[0] - 0 : k.id - 0)))]
        state.absenteesVisible = true
      },
      showGroupTable: () => {
        supervisionLogger.selGroupLogger()
        state.groupVisible = true
      },
      pause() {
        state.pauseVisible = true
      },
      speedStopClick() {
        state.speedStopVisible = true
      },
      groupSubmit: groupLessonsList => {
        state.showToggleBtn = false
        state.showAll = true
        state.selectGroupObj = [...groupLessonsList]
        methods.setSessionStorageRowKeys()
        methods.setToggleBtn()
        clearLoop25s()
        methods.loop25s()
      },
      setSessionStorageRowKeys: () => {
        sessionStorage.setItem('supervision-group-lesson', JSON.stringify(state.selectGroupObj))
      },
      removeSessionStorageRowKeys: () => {
        sessionStorage.removeItem('supervision-group-lesson')
      },
      getSessionStorage: key => {
        const str = sessionStorage.getItem(key)
        if (!str) return null
        const result = JSON.parse(str)
        return result
      },
      clearAll: () => {
        state.selectGroupObj = []
        methods.removeSessionStorageRowKeys()
        methods.setToggleBtn()
        clearLoop25s()
        methods.loop25s()
      },
      refresh: throttle(function(val) {
        this.refreshLoading = true
        setTimeout(() => {
          this.refreshLoading = false
        }, 5 * 1000)
        // 节流5秒
        clearLoop25s()
        methods.loop25s()
      }, 5 * 1000, { trailing: false }),
      delGroup(idx, groupId) {
        if (!state.actionTips) {
          state.selectGroupObj.splice(idx, 1)
          methods.setSessionStorageRowKeys()
          methods.setToggleBtn()
          clearLoop25s()
          methods.loop25s()
          state.actionTips = true
          setTimeout(() => {
            state.actionTips = false
          }, 5 * 1000)
        } else {
          root.$message.warning('操作过于频繁')
        }
      },
      toggleGroupShow: () => {
        state.showAll = !state.showAll
        methods.setScrollY()
      },
      setToggleBtn: () => {
        root.$nextTick(() => {
          const showAllGroup = state.showToggleBtn || (GroupListRef.value && GroupListRef.value.getBoundingClientRect().height > 50)
          const len = state.selectGroupObj.length > 0
          if (len && showAllGroup) {
            state.showToggleBtn = true
          } else {
            state.showToggleBtn = false
          }
          console.log(state.showToggleBtn)
        })
      },
      loop25s: () => {
        getStudentList()
      },
      setScrollY: () => {
        root.$nextTick(() => {
          // const h = document.documentElement.clientHeight || document.body.clientHeight
          const h = document.body.clientHeight
          const bannerRefHeight = Banner.value.offsetHeight
          scroll.y = parseInt(h - bannerRefHeight - 52 - 140)
        })
      },
      lt1280AddStyle: () => {
        const clientW = window.innerWidth
        state.lt1280 = clientW <= 1280 // 小于1280时增加固定列投影
      },
      windowResizeCallback: () => {
        methods.lt1280AddStyle()
        methods.setTableColumnsWidth()
        methods.setScrollY()
      },
      fetchHasJzxGroup: () => {
        console.log('fetchHasJzxGroup', service)
        service.hasJzxGroup({}).then(res => {
          state.hasJzxGroup = res === 1
        })
      }
    }
    watch(() => root.$store.state.common.scalingNum, v => {
      if (v) {
        methods.windowResizeCallback()
      }
    })

    // 左侧课程数据
    const {
      studentTableLoading,
      studentList,
      getStudentList,
      clearLoop25s,
      studyingStudentNumber // 正在学习人数
    } = useGetStudentList(state, refs, methods)

    onMounted(() => {
      const groupLessons = methods.getSessionStorage('supervision-group-lesson')
      if (groupLessons) state.selectGroupObj = groupLessons
      methods.setToggleBtn()
      methods.loop25s()
      methods.lt1280AddStyle()
      // 浏览器视口大小改变时调整表格高度
      window.onresize = methods.windowResizeCallback
      methods.fetchHasJzxGroup()
    })

    onUnmounted(() => {
      window.onresize = null
    })

    const startTime = +new Date()
    onBeforeUnmount(() => {
      clearLoop25s()
      const endTime = +new Date()
      const duration = parseInt((endTime - startTime) / 1000)

      supervisionLogger.pageTmeLogger({
        startTime: Moment(startTime).format('YYYY/MM/DD hh:mm:ss'),
        endTime: Moment(endTime).format('YYYY/MM/DD hh:mm:ss'),
        duration
      })
    })

    return {
      Banner,
      // columns,
      filters,
      GroupListRef,
      scroll,
      studentTableLoading,
      studentList,
      studyingStudentNumber,
      ...methods,
      ...toRefs(state)
    }
  }
}
</script>

<style lang="less">
@import './style.less';
</style>